<div class="landing-popover" *ngIf="open">
  <div class="container">
    <button (click)="goTo('home/contact')" class="landing-button primary filled">Contactar a ventas</button>
    <button  (click)="goTo('auth/login')" class="landing-button primary outlined">Iniciar sesión</button>
  </div>
  <div class="backdrop" (click)="handleClose()"></div>
</div>